/* eslint-disable global-require */

import angular from 'angular';

import BatteryHealthFormController from './battery-health-form.controller';

export default angular.module('autoboard.formBatteryHealth', [])
  .directive('formBatteryHealth', () => {
    'ngInject';

    return {
      controller: BatteryHealthFormController,
      restrict: 'E',
      scope: {
        exit: '&',
        show: '=',
        vehicle: '<',
      },
      templateUrl: require('./battery-health-form.template.html'),
    };
  })
  .name;
